<template>
<div class="g-bg-img-hero" style="background-color: #efefef; background-attachment: fixed">
  <div class="container g-pt-60 g-pb-30">
      <div class="row justify-content-lg-center align-items-md-center">
      <div class="col-md-9 col-lg-7 g-mb-30">
          <!-- Media -->
          <div class="media align-items-center g-pr-15--lg">
            <div class="media-body">
                <h3 class="h3">Don’t see the guide or resource you are looking for?</h3>
                <p class="g-font-size-20"><span v-on:click="ShowModal()" style="cursor: pointer; text-decoration: underline;">Click here</span> and suggest a new resource that would be helpful.</p>
            </div>
          </div>
          <!-- End Media -->
      </div>
      <div class="col-sm-6 col-md-4 col-lg-3 mx-auto g-mx-0--lg g-mb-30">
        <a class="btn btn-block u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-25 g-py-13 g-font-size-18" v-on:click="ShowModal()">Submit a Suggestion</a>
      </div>
      </div>
  </div>
     <suggest-form v-if="isModalShown" @closeWufoo="CloseModal()"></suggest-form>
</div>
</template>
<script>
import SuggestForm from "@/components/portal/resourceData/SuggestForm";
export default {
  components: {SuggestForm},
  data() {
    return{
      isModalShown: false
    }
  },
  methods: {
    ShowModal() {
      this.isModalShown = !this.isModalShown;
      document.body.classList.add("body-overflow");
    },
    CloseModal() {
      this.isModalShown = false;
      document.body.classList.remove("body-overflow");
    }
  }
}
</script>



// WEBPACK FOOTER //
// ResourceSuggest.vue?3a2c110e